import { render, staticRenderFns } from "./BlockType107.vue?vue&type=template&id=c6032164&scoped=true&"
import script from "./BlockType107.vue?vue&type=script&lang=ts&"
export * from "./BlockType107.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType107.vue?vue&type=style&index=0&id=c6032164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6032164",
  null
  
)

export default component.exports